import moment from "moment";

import { BaseManager } from "./index.js";
import { PlatformService } from "@/modules/api.js";

export class LeagueManager extends BaseManager {
  _ServiceClass = PlatformService;

  dataProps = {
    created: "string",
    current_week: "computed",
    draft_date: "string",
    draft_status: "string",
    draft_type: "string",
    id: "number",
    misc: "object",
    name: "string",
    pending_accounts: "object",
    players: "object",
    season_length: "number",
    settings: "object",
    status: "string",
    teams: "object",
    updated: "string"
  };

  get(id) {
    const path = `/api/leagues/${id}/`;
    return this._get(path);
  }

  _getComputedProperties(placeholder) {
    placeholder.current_week = this._getCurrentWeek(placeholder);
    return placeholder;
  }

  /* Utilities */

  getTeam(teamId) {
    return this.data.teams.find(t => t.id == teamId);
  }

  // Determine current week of the season from the draft date.
  _getCurrentWeek(data) {
    if (data.draft_status == "Complete" && data.status != "Complete") {
      let todaysWeek = moment()
        .utc()
        .startOf("week");
      let draftDate = moment(data.draft_date, "YYYY-MM-DD")
        .utc()
        .startOf("week");
      return todaysWeek.diff(draftDate, "weeks");
    } else {
      return null;
    }
  }
}
